import { render } from "./Setting.vue?vue&type=template&id=6dd0d9d8&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=6dd0d9d8&scoped=true&lang=css"
import "./Setting.vue?vue&type=style&index=1&id=6dd0d9d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd0d9d8"]])

export default __exports__